import {Injectable} from '@angular/core';
import {ReportDataSetTemplate} from '@domain/report-data-set/report-data-set-template';
import {Observable, ReplaySubject} from 'rxjs';

@Injectable()
export class ReportDataSetTemplateService {
  private readonly currentReportDataSetTemplate = new ReplaySubject<ReportDataSetTemplate>(1);

  public getCurrentReportDataSetTemplate(): Observable<ReportDataSetTemplate> {
    return this.currentReportDataSetTemplate.asObservable();
  }

  public setCurrentReportDataSetTemplate(reportDataSetTemplate: ReportDataSetTemplate): void {
    this.currentReportDataSetTemplate.next(reportDataSetTemplate);
  }
}
